import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { CONFIRM_LAST_FOUR, QUERY_ACCOUNT } from "../../../api/queryKeys";
import { DebitCardStatusEnum } from "../../../types";

export default function useSetDebitCardStatus() {
  const queryClient = useQueryClient();
  return useMutation<
    any,
    AxiosError,
    { cardId: number; status: DebitCardStatusEnum }
  >(
    ({ cardId, status }) =>
      api.patch(`${CONFIRM_LAST_FOUR}${cardId}/`, {
        tp_status: status,
      }),
    {
      onError: (error) => {
        toast.error("Unable to update debit card status");
      },
      onSuccess: () => {
        queryClient.refetchQueries([QUERY_ACCOUNT]);
      },
    }
  );
}
